import * as FileSaver from 'file-saver'
import moment from 'moment'
import * as XLSX from 'xlsx-js-style'
import { styleTableSheet } from 'utils/excelStyle'

export const handleDownloadExcel = (
  data,
  setIsDownload,
  setFirstRows,
  setTotalRows,
  columns,
  name,
  date,
) => {
  setIsDownload(false)
  setFirstRows(0)
  setTotalRows(0)

  setTimeout(() => {
    setIsDownload(true)
    setFirstRows(0)
    setTotalRows(data?.totalItems)

    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const bookType = 'xlsx'
    let count = 2

    const totalItems = data.totalItems || data.items.length
    const chunkSize = Math.max(Math.floor(totalItems * 0.1), 100)

    const exportHeader = columns
      .filter((col) => col.name && typeof col.name === 'object')
      .map((col) => col.name.props.children ?? '')

    const ws = XLSX.utils.book_new()
    XLSX.utils.sheet_add_aoa(ws, [exportHeader])

    const processChunk = (start) => {
      if (start >= totalItems) {
        setFirstRows(totalItems)
        setTimeout(() => {
          styleTableSheet(ws)
          const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
          const excelBuffer = XLSX.write(wb, { bookType, type: 'array' })
          const finalData = new Blob([excelBuffer], { type: fileType })

          FileSaver.saveAs(
            finalData,
            `Absensi_${name}_${moment(date[0]).format('DD-MM-YYYY')}-${moment(date[1]).format('DD-MM-YYYY')}.xlsx`,
          )

          setTimeout(() => {
            setIsDownload(false)
          }, 2000)
        }, 500)

        return
      }

      const dataSelectors = columns
        .filter((col) => col.selector)
        .map((col) => col.selector)

      const chunk = data?.items?.slice(start, start + chunkSize)?.map((row) =>
        dataSelectors.map((selectorFn) => {
          try {
            let value = selectorFn(row)
            if (typeof value === 'string') {
              return value.replace(/<br\s*\/?>/g, '\n')
            }
            return value ?? '-'
          } catch (e) {
            return '-'
          }
        }),
      )

      XLSX.utils.sheet_add_json(ws, chunk, {
        origin: `A${count}`,
        skipHeader: true,
      })
      count += chunk.length
      setFirstRows(start + chunk.length)

      setTimeout(() => processChunk(start + chunkSize), 300)
    }

    processChunk(0)
  }, 300)
}
